'use strict';

export default function () {
  // const wrapper = document.querySelector('.c-wrapper');
  // const footer = document.querySelector('.c-footer');
  // const footerHeight = footer.offsetHeight;
  // wrapper.style.paddingBottom = `${footerHeight}px`;
}
